// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  stamp: __t.string().primaryKey(),
  adminOrgId: __t.string().name("admin_org_id"),
  isHouse: __t.bool().name("is_house"),
  webclientBaseUrl: __t.option(__t.string()).name("webclient_base_url"),
  githubAppInstallUrl: __t.option(__t.string()).name("github_app_install_url"),
  crossDeploymentSupport: __t.bool().name("cross_deployment_support"),
  updatedAt: __t.timestamp().name("updated_at"),
  updatedBy: __t.identity().name("updated_by"),
});
